import { useGetOrganization } from "@/entities/organization";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import { OrganizationEdit } from "./OrganizationEdit.component";

export const OrganizationEditWrapper = ({ organizationId }) => {
  const { organization, isLoading } = useGetOrganization(organizationId);

  return (
    <FetchItemWrapper
      item={organization}
      loading={isLoading}
      renderContent={(organization) => (
        <OrganizationEdit model={organization} />
      )}
    />
  );
};
